export const ITEM_CREATE = 'ITEM_CREATE'
export const ITEM_DELETE = 'ITEM_DELETE'

export const COMMENT_CREATE = 'COMMENT_CREATE'
export const COMMENTS_DELETE = 'COMMENTS_DELETE'

export const ITEM_SELECT = 'ITEM_SELECT'
